import { jsx as o, jsxs as f } from "react/jsx-runtime";
import "styled-components";
import { useThemeInMode as d } from "../../../context/theme/hooks.js";
import "../../layout/Stack/Stack.js";
import n from "../../layout/Box/Box.js";
import "react";
import "../../../index-CZ8zjHGv.js";
import "../../layout/Center/Center.js";
import a from "../../layout/Column/Column.js";
import w from "../../layout/Columns/Columns.js";
import "../../layout/Columns/ColumnsContext.js";
import "../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import D from "../../typography/Text/Text.js";
import "../../../context/Text.js";
import "../../../context/Typography.js";
import "../../../hooks/link/index.js";
import { logoVariantMap as L, logoDescriptions as v } from "./consts.js";
function J(i) {
  const {
    variant: t = "default",
    text: e,
    textSize: m,
    width: c,
    height: r,
    dividerSpacing: p,
    maxWidth: g,
    maxHeight: h
  } = i, s = d(), u = L[t], { description: x } = v[t], l = /* @__PURE__ */ o(
    u,
    {
      color: s.logo,
      "aria-label": x,
      width: "auto",
      height: r ?? "100%",
      maxHeight: h
    }
  );
  return /* @__PURE__ */ o(
    n,
    {
      width: c,
      height: r,
      maxWidth: g,
      maxHeight: h,
      children: e ? /* @__PURE__ */ o(
        C,
        {
          logo: l,
          text: e,
          textSize: m,
          dividerHeight: r,
          dividerSpacing: p
        }
      ) : l
    }
  );
}
function C({
  logo: i,
  text: t,
  textSize: e = "medium",
  dividerHeight: m,
  dividerSpacing: c = "large"
}) {
  const r = d();
  return /* @__PURE__ */ f(w, { alignY: "center", space: c, children: [
    /* @__PURE__ */ o(a, { width: "content", children: i }),
    /* @__PURE__ */ o(a, { width: "content", children: /* @__PURE__ */ o(T, { height: m }) }),
    /* @__PURE__ */ o(a, { width: "content", children: /* @__PURE__ */ o(n, { textDecoration: "none", children: /* @__PURE__ */ o(D, { tone: "primary", size: e, truncate: !0, children: /* @__PURE__ */ o(n, { textDecoration: "none", color: r.logo, children: t }) }) }) })
  ] });
}
function T({ height: i = "auto" }) {
  const t = d();
  return /* @__PURE__ */ o(
    n,
    {
      height: i,
      width: "1px",
      display: "flex",
      backgroundColor: t.logo
    }
  );
}
export {
  J as default
};
